import React from "react";

const NavbarCajero = ({
  nombreCajero, nombrePlantel, onCerrarSesion,
  esAdministrador, catalogoPlanteles, plantelRevisionId, onCambiarPlantelRevision
}) => {
  return (
    <nav className="Dashboard-navbar">
      <div className="navbar-user">
        <span className="user-badge">
          <strong>{nombreCajero}</strong> | {nombrePlantel}
        </span>

        {esAdministrador && (
          <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "0.85rem" }}>
            <label htmlFor="selector-plantel-revision" style={{ color: "#fff", opacity: 0.85 }}>
              👁️ Ver plantel:
            </label>
            <select
              id="selector-plantel-revision"
              value={plantelRevisionId}
              onChange={(e) => onCambiarPlantelRevision(e.target.value)}
              style={{ padding: "4px 8px", borderRadius: "4px", border: "1px solid #ccc" }}
            >
              {(catalogoPlanteles || []).map((p) => (
                <option key={p.id} value={p.id}>{p.nombre_plantel}</option>
              ))}
            </select>
          </span>
        )}

        <button onClick={onCerrarSesion} className="btn-logout">
          Salir
        </button>
      </div>
    </nav>
  );
};

export default NavbarCajero;